export default "__VITE_ASSET__C8GeksT3__"